<script>
import { cloneDeep, debounce } from "lodash";
import isEqual from "lodash/isEqual";

export default {
  name: "popupTreeSelect",
  components: {},
  props: {
    //是否开启多选
    multiple: {
      type: Boolean,
      default: false
    },
    //是否开启搜索
    search: {
      type: Boolean,
      default: false
    },
    //搜索框 过滤值
    searchFilter: {
      type: [String, Array, Function],
      default: () => ["text", "simpleCode"]
    },
    //搜索框 提示
    searchPlaceholder: {
      type: String,
      default: ""
    },
    //显示隐藏
    visible: {
      type: Boolean,
      default: false
    },
    //选中值
    value: {
      type: [Array, String, Number],
      default: ""
    },
    //下拉数据
    options: {
      type: Array,
      default: () => []
    },
    //id 参数
    valueField: {
      type: String,
      default: "id"
    },
    //文字参数
    labelField: {
      type: String,
      default: "name"
    },
    //子级参数
    childrenField: {
      type: String,
      default: "children"
    },
    //禁用field
    disabledField: {
      type: String,
      default: "disabled"
    },
    //是否带有确认框
    isConfirm: {
      type: Boolean,
      default: true
    },
    //确认之前  判断
    confirmBefore: {
      type: Function,
      default: null
    },
    //确认文字描述
    confirmButtonText: {
      type: String,
      default: "确认"
    },
    //取消文字描述
    cancelButtonText: {
      type: String,
      default: "取消"
    },
    //点击取消 是否清空数据
    isClear: {
      type: Boolean,
      default: false
    },
    //最大数量
    max: {
      type: [String, Number],
      default: Infinity
    },
    //弹窗高度
    height: {
      type: String,
      default: "60vh"
    },
    //挂载容器
    getContainer: {
      type: String,
      default: "#app"
    },
    //点击遮罩层是否关闭
    closeOnClickOverlay: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      realValue: this.multiple ? [] : "",
      defaultOptions: [],
      visibleOptions: [],
      searchValue: "",
      mainActiveIndex: 0
    };
  },
  model: {
    prop: "visible"
  },
  watch: {
    visible() {
      this.onVisibleChange();
    },
    options() {
      this.initData();
    },
    realValue(e) {
      if (!this.isConfirm && !isEqual(this.value, e)) {
        this.$emit("update:value", e);
      }
    }
  },
  computed: {},
  created() {
    this.initData();
  },
  methods: {
    onVisibleChange() {
      let { value, multiple } = this;
      this.searchValue = "";
      this.realValue = multiple && !(value instanceof Array) ? [] : value;
      this.mainActiveIndex = this.onMainActiveIndexInit();
    },
    /**
     * @description: 初始化数据
     * @param {*}
     * @return {*}
     */
    initData() {
      let defaultOptions = this.initDataRender(cloneDeep(this.options));
      this.defaultOptions = defaultOptions;
      this.visibleOptions = defaultOptions;
    },
    /**
     * @description: 重构数据
     * @param {*}
     * @return {*}
     */
    initDataRender(data) {
      let { valueField, labelField, childrenField, disabledField } = this;
      return data.map(p => {
        p.id = p[valueField];
        p.text = p[labelField];
        p.disabled = p[disabledField];
        if (p[childrenField] && p[childrenField].length > 0) {
          p.children = this.initDataRender(p[childrenField]);
        }
        return p;
      });
    },
    /**
     * @description: 重置左侧选中索引
     * @param {*}
     * @return {*}
     */
    onMainActiveIndexInit() {
      let { multiple, realValue, defaultOptions } = this;
      let index = -1;
      if (defaultOptions.length > 0) {
        for (let i = 0; i < defaultOptions.length; i++) {
          let item = defaultOptions[i];
          if (item.children && item.children.length > 0) {
            for (let j = 0; j < item.children.length; j++) {
              let dItem = item.children[j];
              if (multiple) {
                if (realValue.includes(dItem.id)) {
                  index = i;
                  break;
                }
              } else if (realValue == dItem.id) {
                index = i;
                break;
              }
            }
          }
          if (index > -1) break;
        }
      }
      return index == -1 ? 0 : index;
    },
    /**
     * @description: 搜索
     * @param {*}
     * @return {*}
     */
    onSearch: debounce(function() {
      let that = this;
      that.$nextTick(() => {
        that.visibleOptions = that.onSearchFilterData(
          cloneDeep(that.defaultOptions)
        );
        that.mainActiveIndex = 0;
      });
    }, 300),
    /**
     * @description: 搜索过滤数据
     * @param {*} data
     * @param {*} lv 递归级数  预留参数
     * @return {*}
     */
    onSearchFilterData(data, lv = 0) {
      if (lv > 1) return data;
      let that = this;
      let { searchValue, searchFilter } = this;
      if (searchValue && searchFilter) {
        if (typeof searchFilter == "string") {
          data = data.filter(p => {
            return (
              that.defaultSearchFilter(p, searchFilter) ||
              (lv == 0 &&
                p.children &&
                p.children.length > 0 &&
                that.onSearchFilterData(p.children, lv + 1))
            );
          });
        } else if (searchFilter instanceof Array) {
          data = data.filter(p => {
            for (let i = 0; i < searchFilter.length; i++) {
              let key = searchFilter[i];
              if (that.defaultSearchFilter(p, key)) {
                return true;
              }
            }
            if (lv == 0 && p.children && p.children.length > 0) {
              p.children = that.onSearchFilterData(p.children, lv + 1);
              return p.children.length > 0;
            }
            return false;
          });
        }
      }
      return data;
    },
    /**
     * @description: 默认过滤方法
     * @param {*}
     * @return {*}
     */
    defaultSearchFilter(p, searchFilter) {
      let { searchValue } = this;
      let value = p[searchFilter];
      return (
        (value || value == 0) &&
        value.toLowerCase().indexOf(searchValue.toLowerCase()) > -1
      );
    },
    /**
     * @description: 点击选项
     * @param {*}
     * @return {*}
     */
    onClickItem(row) {
      let { multiple, realValue } = this;
      if (!multiple) {
        let value = row[this.valueField];
        if (!multiple && realValue == value) {
          value = "";
        }
        this.realValue = value;
      }
      if (!this.isConfirm) {
        this.confirm();
      }
    },
    /**
     * @description: 获取数据
     * @param {*}
     * @return {*}
     */
    getData() {
      return this.realValue;
    },
    /**
     * @description: 确认
     * @param {*}
     * @return {*}
     */
    confirm() {
      let { multiple, defaultOptions } = this;
      let value = this.realValue;
      let rows;
      if (multiple) {
        rows = [];
        for (let i = 0; i < defaultOptions.length; i++) {
          let item = defaultOptions[i];
          if (multiple && rows.length == value.length) break;
          for (let j = 0; j < item.children.length; j++) {
            let dItem = item.children[j];
            if (value.includes(dItem.id)) {
              rows.push(dItem);
            }
          }
        }
      } else {
        for (let i = 0; i < defaultOptions.length; i++) {
          let item = defaultOptions[i];
          if (rows) break;
          for (let j = 0; j < item.children.length; j++) {
            let dItem = item.children[j];
            if (value.includes(dItem.id)) {
              rows = dItem;
            }
          }
        }
      }

      if (!this.confirmBefore || this.confirmBefore(value, rows) !== false) {
        this.$emit("input", false);
        this.$emit("update:value", value);
        this.$emit("confirm", value, rows);
      }
    },
    /**
     * @description: 取消
     * @param {*}
     * @return {*}
     */
    cancel() {
      if (this.isClear) {
        this.confirm("");
      } else {
        this.$emit("input", false);
        this.$emit("cancel");
      }
    },
    /**
     * @description: 弹窗 渲染
     * @param {*}
     * @return {*}
     */
    popupRender() {
      const option = {
        props: {
          position: "bottom",
          value: this.visible,
          "get-container": this.getContainer,
          closeOnClickOverlay: this.closeOnClickOverlay
        },
        on: {
          input: e => {
            this.$emit("input", e);
          }
        }
      };
      return (
        <van-popup {...option}>
          {this.confirmRender()}
          {this.searchRender()}
          {this.treeSelectRender()}
        </van-popup>
      );
    },
    /**
     * @description: 搜索 渲染
     * @param {*}
     * @return {*}
     */
    searchRender() {
      let that = this;
      if (that.search) {
        return (
          <van-search
            {...{
              class: "search",
              props: {
                value: this.searchValue,
                placeholder: this.searchPlaceholder
              },
              on: {
                input: e => {
                  that.searchValue = e;
                  that.onSearch();
                }
              }
            }}
          />
        );
      }
    },
    /**
     * @description: 树形选择 渲染
     * @param {*}
     * @return {*}
     */
    treeSelectRender() {
      return (
        <van-tree-select
          {...{
            class: "list",
            props: {
              height: this.height,
              max: this.max,
              activeId: this.realValue,
              mainActiveIndex: this.mainActiveIndex,
              items: this.visibleOptions
            },
            on: {
              "update:main-active-index": e => {
                this.mainActiveIndex = e;
              },
              "update:active-id": e => {
                if (this.multiple) {
                  this.realValue = e;
                }
              },
              "click-item": this.onClickItem
            }
          }}
        />
      );
    },
    /**
     * @description: 确认|取消 渲染
     * @param {*}
     * @return {*}
     */
    confirmRender() {
      if (this.isConfirm) {
        return (
          <div class="select-head van-hairline--top-bottom van-picker__toolbar">
            <button class="van-picker__cancel" onClick={this.cancel}>
              {this.cancelButtonText}
            </button>
            <button class="van-picker__confirm" onClick={this.confirm}>
              {this.confirmButtonText}
            </button>
          </div>
        );
      }
    }
  },
  render() {
    return this.popupRender();
  }
};
</script>

<style lang="less" scoped>
/deep/.search .van-cell__value {
  text-align: left;
}
</style>
